import React from 'react';
import ReactDOM from 'react-dom/client';
import Departures from './components/Departures';
import Mensa from './components/Mensa';
import { departuresData } from './sampleData';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className="container-fluid p-4">
      <div className="row">
        <div className='col-4'>
            <Departures data={departuresData}/>
        </div>
        <div className='col-4'>
            <Mensa location="102" date="2024-12-19" time="evening"/>
        </div>
      </div>
    </div>
  </React.StrictMode>
);
